<template>
  <div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="grid">
        <div class="col-12">
          <div class="formgrid grid">
            <div class="field col-12 md:col-12">
              <label>Nama</label>
              <InputText
                ref="sat"
                v-model="form.sat"
                :class="{ 'p-invalid': v$.form.sat.$invalid && submitted }"
                class="w-full"
                input-class="w-full"
                maxlength="3"
                @keydown.space.prevent
                @keypress="isLetter($event)"
                @keydown="handleKeydownField($event, 'active')"
              />
              <small
                v-if="
                  (v$.form.sat.$invalid && submitted) ||
                  v$.form.sat.$pending.$response
                "
                class="p-error"
              >
                <span v-if="v$.form.sat.required.$invalid">
                  {{ v$.form.sat.required.$message }}
                </span>
                <span v-else> {{ v$.form.sat.maxLength.$message }}</span>
              </small>
            </div>
            <div class="field col-12 md:col-3">
              <label></label>
              <input
                ref="active"
                :checked="form.active"
                type="checkbox"
                id="active"
                @click="OnCheckClick"
                @keydown="handleKeydownField($event, 'btnSave')"
              /><label for="active">Aktif</label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-content-end align-items-end">
        <Button
          label="Tutup"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-text mr-2"
        />
        <Button
          :loading="loading"
          label="Simpan"
          icon="pi pi-check"
          type="submit"
          ref="btnSave"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { focusNextField, handleKeydownField } from '@/helpers'
import useVuelidate from '@vuelidate/core'
import { helpers, maxLength, required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      submitted: false,
    }
  },
  async mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        focusNextField(this, 'sat')
      }, 100)
    })
  },
  computed: {
    form() {
      return this.item
    },
  },
  methods: {
    handleSubmit(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      this.$emit('save', this.form)
    },
    OnCheckClick() {
      // for casting active checkbox checked value to int
      this.form.active = this.form.active == 0 ? 1 : 0
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z]+$/.test(char)) return true
      else e.preventDefault()
    },

    handleKeydownField(event, nextRef, selectAll = false) {
      handleKeydownField(this, event, nextRef, selectAll)
    },
  },
  validations() {
    return {
      form: {
        sat: {
          required: helpers.withMessage('Nama harus diisi.', required),
          maxLength: helpers.withMessage(
            'Nama maksimal memiliki 3 karakter.',
            maxLength(3)
          ),
        },
      },
    }
  },
}
</script>
